import React, { useEffect, useState } from "react";
import Loading from "../LoaderPageSection/Loading";
import Logo from "../../../image/Logo.png";
import Layout from "../Layout/Content";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useAuth } from "../../context/auth";
import { ethers } from "ethers";
import { stakeNv1ContractAddress, stakeNv1ContractABI } from "../Abi/Content";

const Content = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [auth, setAuth] = useAuth({});
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [copytext, setCopyText] = useState("copy");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [stakeMenuOpen, setStakeMenuOpen] = useState(true);
  const [isOwner, setIsOwner] = useState(false);

  const start_and_end = (address) => {
    if (address !== undefined) {
      return (
        address.substr(0, 10) +
        "...." +
        address.substr(address.length - 10, address.length)
      );
    }
    return address;
  };

  const handleCopy = () => {
    setCopyText("Copied!");
    let text = `https://stake.decentrawood.com/?${address}`;
    text.trim();
    navigator.clipboard.writeText(text);
  };

  setTimeout(() => {
    setCopyText("copy");
  }, 2000);

  const handleLogout = () => {
    setAuth({ ...auth, user: null });
    localStorage.removeItem("auth");
    localStorage.removeItem("isStakeApproved");
    localStorage.removeItem("stake_amount");
    localStorage.removeItem("stake_loading");
    navigate("/");
  };

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    if (
      auth?.user?.address &&
      auth?.user?.referralAddress &&
      auth?.user?.token
    ) {
      setAddress(auth?.user?.address);
    }
  }, [auth]);

  useEffect(() => {
    const checkOwnerStatus = async () => {
      if (!address) {
        setIsOwner(false);
        return;
      }
      const lowerAddress = address.toLowerCase();
      // Hardcoded known admin/owner addresses
      const knownAdmins = [
        "0x4c521a1A1F77D0bd19519f2F9b635a3626B619AF".toLowerCase()  ,
        "0x7f967ec284cE3E3503C19dB74dc697aEa4c0F2".toLowerCase(),
        "0x2aa5f670f789c7630ffddc80c6efecb2f06128ff".toLowerCase(),
        "0xbe99181bcab37bc57d3d2c7156bb7e1b72aafba2".toLowerCase()
      ];

      if (knownAdmins.includes(lowerAddress)) {
        setIsOwner(true);
        return;
      }

      try {
        if (window?.ethereum) {
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const contract = new ethers.Contract(
            stakeNv1ContractAddress,
            stakeNv1ContractABI,
            provider
          );
          const ownerAddress = await contract.owner();
          if (ownerAddress && ownerAddress.toLowerCase() === lowerAddress) {
            setIsOwner(true);
            return;
          }
        }
      } catch (error) {
        console.error("Error checking owner status in Content:", error);
      }
      setIsOwner(false);
    };

    checkOwnerStatus();
  }, [address]);

  return (
    <>
      <Layout title={"Dashboard"}>
        {loading && <Loading loading={loading} />}

        {/* Mobile sidebar toggle */}
        <button
          className="sidebar-toggle-btn"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <i className="bi bi-list"></i>
        </button>

        {/* Sidebar overlay for mobile */}
        <div
          className={`sidebar-overlay ${sidebarOpen ? "active" : ""}`}
          onClick={() => setSidebarOpen(false)}
        ></div>

        <div className="dashboard-layout">
          {/* CodingLab Sidebar */}
          <aside className={`sidebar ${isClosed ? "close" : ""} ${sidebarOpen ? "sidebar-open" : ""}`}>
            <div className="logo-details">
              {/* <div className="logo_name text-white">
                <img src={Logo} alt="logo" style={{ width: '30px', marginRight: '10px' }} />
                <span>Decentrawood</span>
              </div> */}
              <i className="bi bi-list" id="btn" onClick={() => setIsClosed(!isClosed)}></i>
            </div>

            <ul className="nav-list">
              {/* <li>
                <i className="bi bi-search" onClick={() => setIsClosed(false)}></i>
                <input type="text" placeholder="Search..." />
                <span className="tooltip">Search</span>
              </li> */}

              {/* Home */}
              <li>
                <a onClick={() => { navigate("/stake6"); setSidebarOpen(false); }}>
                  <i className="bi bi-house-door"></i>
                  <span className="links_name">Home</span> 
                </a>
                <span className="tooltip">Home</span>
              </li>
              {/* Stake 6 */}
              <li className={isActive("/stake6") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stake6"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake 6</span>
                </a>
                <span className="tooltip">Stake 6</span>
              </li>
              {/* Stake 7 */}
              {/* <li className={isActive("/stake7") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stake7"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake 7</span>
                </a>
                <span className="tooltip">Stake 7</span>
              </li> */}
              {/* Stake 5 */}
              <li className={isActive("/stake5") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stake5"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake 5</span>
                </a>
                <span className="tooltip">Stake 5</span>
              </li>

              {/* Stake 4 */}
              <li className={isActive("/stakefour") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stakefour"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake 4</span>
                </a>
                <span className="tooltip">Stake 4</span>
              </li>


              {/* Stake 3 */}
              <li className={isActive("/stakethree") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stakethree"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake 3</span>
                </a>
                <span className="tooltip">Stake 3</span>
              </li>
              {/* Stake 2 */}
              <li className={isActive("/staketwo") ? "active-item" : ""}>
                <a onClick={() => { navigate("/staketwo"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake 2</span>
                </a>
                <span className="tooltip">Stake 2</span>
              </li>

              {/* Stake A */}
              <li className={isActive("/stakeone") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stakeone"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake 1</span>
                </a>
                <span className="tooltip">Stake 1</span>
              </li>

              {/* Stake A */}
              <li className={isActive("/stakeA") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stakeA"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Stake A</span>
                </a>
                <span className="tooltip">Stake A</span>
              </li>
              {/* Stake N */}
              {isOwner && (
                <li className={isActive("/stakeN") ? "active-item" : ""}>
                  <a onClick={() => { navigate("/stakeN"); setSidebarOpen(false); }}>
                    <i className="bi bi-stack"></i>
                    <span className="links_name">Stake N</span>
                  </a>
                  <span className="tooltip">Stake N</span>
                </li>
              )}
              {/* Stake Nv1 */}
              <li className={isActive("/stakeNv1") ? "active-item" : ""}>
                <a onClick={() => { navigate("/stakeNv1"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">{isOwner ? "Stake N v1" : "Stake N"}</span>
                </a>
                <span className="tooltip">{isOwner ? "Stake N v1" : "Stake N"}</span>
              </li>
              <li className={isActive("/learnmore") ? "active-item" : ""}>
                <a onClick={() => { navigate("/learnmore"); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Learn More</span>
                </a>
                <span className="tooltip">Learn More</span>
              </li>
              <li className={""}>
                <a onClick={() => { handleLogout(); setSidebarOpen(false); }}>
                  <i className="bi bi-stack"></i>
                  <span className="links_name">Logout</span>
                </a>
                <span className="tooltip">Logout</span>
              </li>
            </ul>

            {/* Sidebar Footer — Previous Logout Style */}
            {/* <div className="sidebar-footer">
              <button className="logout-btn" onClick={handleLogout}>
                <i className="bi bi-box-arrow-left"></i>
                <span className="logout-text">Logout</span>
              </button>
            </div> */}
          </aside>

          {/* Main Content Area */}
          <div className="dashboard-main">
            {/* Referral Link */}
            {/* <div className="referral-box">
              <p style={{ fontWeight: 600 }}>Referral Link:</p>
              <span className="ref-link-text">
                https://stake.decentrawood.com/?{start_and_end(address)}
              </span>
              <CopyToClipboard
                text={`https://stake.decentrawood.com/?${address}`}
                onCopy={handleCopy}
              >
                <button className="claim-btn-outline" style={{ marginTop: 0, padding: "6px 16px", fontSize: "12px" }}>
                  <i className="fa-solid fa-copy" style={{ marginRight: "6px" }}></i>
                  {copytext}
                </button>
              </CopyToClipboard>
            </div> */}

            {children}
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Content;
